var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.999,
    height: 100.002,
    viewBox: "0 0 89.999 100.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_49452",
    "data-name": "\\uADF8\\uB8F9 49452",
    transform: "translate(-915 -1056.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_19",
    "data-name": "\\uD569\\uCE58\\uAE30 19",
    d: "M-3200.758,22209.637A45.007,45.007,0,0,1-3240,22165a45,45,0,0,1,45-45,45,45,0,0,1,45,45,45.009,45.009,0,0,1-39.24,44.637L-3195,22220Z",
    transform: "translate(4155 -21063)",
    fill: "#35ade3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_8733",
    "data-name": "\\uD328\\uC2A4 8733",
    d: "M31.413,0C14.092,0,0,13.38,0,29.826a28.491,28.491,0,0,0,1.059,7.708,11.074,11.074,0,0,0,9.863,8.116q.428.028.856.028A13.2,13.2,0,0,0,21.284,41.7l5.957,5.923a5.491,5.491,0,0,0,7.645.057l6.979-6.737a17.949,17.949,0,0,0,3.541,1.84,19.993,19.993,0,0,0,9.133.834,27.94,27.94,0,0,1-23.126,11.99,28.146,28.146,0,0,1-17-5.574A2.022,2.022,0,1,0,12,53.273a32.161,32.161,0,0,0,19.418,6.379,32.526,32.526,0,0,0,17.028-4.758A30.411,30.411,0,0,0,59.85,42.513l.3-.635a2.431,2.431,0,0,0-3.507-3.083c-2.171,1.376-7.521,1.123-9.73.236a16.428,16.428,0,0,1-2.035-.968c4.121-4.169,5.984-8.526,5.987-13.869,0,0,0-.006,0-.009,0-6.159-4.07-11.17-9.073-11.17s-9.073,5.011-9.073,11.17c0,5.025,2.076,9.727,6.177,14l-6.819,6.583a1.425,1.425,0,0,1-1.984-.015l-7.615-7.572c-4.6-4.74-6.472-8.507-6.472-13,0-3.862,2.3-7.125,5.029-7.125s5.029,3.263,5.029,7.125a21.8,21.8,0,0,1-2.134,9.464,2.022,2.022,0,1,0,3.65,1.742,25.815,25.815,0,0,0,2.528-11.206c0-6.159-4.07-11.17-9.074-11.17s-9.073,5.011-9.073,11.17c0,6.321,3.122,10.936,6.494,14.628a9.171,9.171,0,0,1-7.268,2.8A7.023,7.023,0,0,1,4.953,36.44a24.446,24.446,0,0,1-.909-6.614c0-14.216,12.277-25.781,27.368-25.781S58.781,15.61,58.781,29.826a2.022,2.022,0,1,0,4.045,0C62.826,13.38,48.734,0,31.413,0M41.792,17.059c2.725,0,5.027,3.26,5.029,7.12,0,0,0,0,0,.005,0,4.322-1.512,7.757-5,11.213-3.4-3.529-5.061-7.211-5.061-11.213,0-3.862,2.3-7.125,5.029-7.125",
    transform: "translate(928.587 1071)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map_marker.8f703b5c99a8d76c9aa7d6a3ef7de4af.svg";
export { ForwardRef as ReactComponent };